/** PDF is not paginated and must fit every column on one page, so this sits well below Excel's 500_000. */
export const GENERAL_LEDGER_PDF_MAX_ROWS = 10_000;
